<template>
  <div class="box">
    <div class="box-top vs-column vs-align-center">
      <div class="box-top-title vs-row vs-align-center vs-space-between">
        <div class="vs-column box-top-title-content">
          <div class="font-weight width-100 text-left font-36 color-black3 margin-bottom-30">12348公共法律服务热线</div>
          <div class="width-100 text-left font-22 color-92 margin-bottom-30">“12348"是自治区司法厅面向全区群众的法律咨询专用热线，它受理解答群众的法律咨询，配合调处民间纠纷，及时反映群众的法律需求信息，指导和接受法律援助申请，维护司法公正、社会稳定及贫弱当事人的合法权益。</div>
        </div>
        <img class="img2" src="../assets/img/img2.jpg">
      </div>
      <div class="box-top-title-text-title box-top-title-text-title1 font-32 color-black3 margin-bottom-25">12348热线介绍</div>
      <div class="box-top-title-text-content font-16 color-92">
        “12348”为全国统一的公共法律服务热线，群众随时随地拨打“12348" 均可获得专业、免费的法律咨询服务，以及法律援助、人民调解、公证等其他各种法律服务。2019年初，广西在“12348” 法律援助热线基础上，统筹全区法律服务热线资源，改造升级为广西“12348”公共法律服务热线，并组建了专业运维和服务团队。据统计，广西“12348”累计呼入量共计380625次。2021年上半年，广西12348公共法律服务热线累计呼入量共计139913次，其中自助语音查询11532次，人工服务咨询133049次，年度接通率95.09%，年度满意度为98.51%。
      </div>
    </div>
    <div class="box-bottom vs-column vs-align-center">
      <div class="box-top-title-text-title font-32 color-black3 margin-bottom-25">服务团队</div>
      <div class="box-top-title-text-swiper margin-bottom-30">
        <swiper :options="swiperOption">
          <swiper-slide class="benefitBox" v-for="(item, index) in list" :key="index">
            <div class="box1" :style="{backgroundImage: 'url(' + item.img + ')', backgroundSize:'100% 100%'}" ></div>
          </swiper-slide>
        </swiper>
      </div>
      <div class="pagin-box vs-row vs-space-center">
        <div v-for="(item, index) in 5" :key="index" class="pagin" :class="index===index1?'pagin-active':''"></div>
      </div>
  </div>
  </div>
</template>

<script>
  export default {
    name: 'hot',
    data () {
      const self = this
      return {
        list: [
           {img: require('@/assets/img/img1.jpg')},
           {img: require('@/assets/img/img2.jpg')},
           {img: require('@/assets/img/img3.jpg')},
           {img: require('@/assets/img/img4.jpg')},
           {img: require('@/assets/img/img5.jpg')},
         ],
        index1: 2,
        swiperOption: {
          slidesPerView: 3.4,
          centeredSlides: true,
          // loop: true,
          initialSlide :2,
          touchRatio: 1, //触摸距离与slide滑动距离的比率。
          spaceBetween: 0,
          on:{
            // 使用es6的箭头函数，使this指向vue对象
            slideChangeTransitionEnd: function(swiper,event){
              self.index1 = swiper.activeIndex
              self.$forceUpdate()
            },
          }
        }
      }
    },
    methods: {
    }
  }
</script>

<style scoped>
  .bg {
    border-radius: 5px;
    background-color: rgb(192, 192, 192);
    box-shadow: 0px 0px 25px 0px rgba(165, 165, 165, 0.3);
    position: absolute;
    left: 1282px;
    top: 1180px;
    width: 424px;
    height: 272px;
    z-index: 33;
  }

.color-92 {
  color: #929292;
}
.box {
    width: 100%;
    min-width: 920px;
  font-family: "Microsoft YaHei"!important;
  }
.box-top{
  width: 100%;
  height: 923px;
  background-image: url("../assets/img/bg3.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;
  padding: 106px 390px 80px;
}
.box-bottom {
  width: 100%;
  margin-top: 60px;
  background-color: #fafdfe;
  padding-top: 50px;
  padding-bottom: 60px;
}
  .box-top-title {
    width: 100%;
    margin-bottom: 153px;
  }
  .img2 {
    box-shadow: 0px 0px 25px 0px rgba(78, 73, 73, 0.3);
  }
  .box-top-title-content  {
    width: 400px;
  }
  .text-left {
    text-align: left;
  }
  .QRcode {
    width: 200px;
    height: 200px;
  }
  .box-top-title-text-title {
    width: 144px;
    height: 74px;
    line-height: 74px;
    background-image: url("../assets/img/title-bg.png");
    background-repeat: no-repeat;
    background-size: 100% 100%;
  }
  .box-top-title-text-title1 {
    width: 290px;
    background-image: url("../assets/img/title-bg1.png") !important;
  }
  .box-top-title-text-content {
    line-height: 35px;
    text-align: left;
    text-indent: 40px;
  }
  .box-top-title-text-swiper {
    width: 100%;
  }
.box-top-title-text-swiper .box1 {
  width: 580px;
  height: 380px;
  border-radius: 5px;
  background-color: rgb(192, 192, 192);
  box-shadow: 0px 0px 25px 0px rgba(165, 165, 165, 0.3);
}
.benefitBox {
}
.box-top-title-text-swiper .swiper-slide:not(.swiper-slide-active) {
  transition: 400ms;
  transform: scale(0.85);
}
  .font-weight {
    font-weight: bold;
  }
  .pagin-box {
    width: 100%;
    height: 30px;
  }
  .pagin {
    background-color: rgb(212, 212, 212);
    width: 20px;
    height: 10px;
    margin: 10px 6px;
    border-radius: 8px;
  }
  .pagin-active {
    background-color: rgb(15, 123, 255);
    width: 30px;
    height: 10px;
  }


  @media (max-width: 1800px) {
    .box-top {
      padding: 106px 180px 80px;
    }
  }
  @media (max-width: 1520px) {
    .box-top {
      padding: 106px 130px 80px;
    }
  }
</style>




// WEBPACK FOOTER //
// src/views/hot.vue